// Sugalarm — /api/emergency-contacts wrappers (cycle 59).

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  EmergencyContact,
  EmergencyContactCreateIn,
  EmergencyContactListResponse,
  EmergencyContactUpdateIn,
  SmsTestResponse,
  VerifyStartResponse,
  VoiceTestResponse,
} from "../lib/types";

export function list(): Promise<ApiResult<EmergencyContactListResponse>> {
  return request<EmergencyContactListResponse>("/api/emergency-contacts");
}

export function create(
  body: EmergencyContactCreateIn,
): Promise<ApiResult<EmergencyContact>> {
  return request<EmergencyContact>("/api/emergency-contacts", {
    method: "POST",
    body,
  });
}

export function update(
  id: string,
  body: EmergencyContactUpdateIn,
): Promise<ApiResult<EmergencyContact>> {
  return request<EmergencyContact>(`/api/emergency-contacts/${id}`, {
    method: "PATCH",
    body,
  });
}

export function remove(id: string): Promise<ApiResult<void>> {
  return request<void>(`/api/emergency-contacts/${id}`, {
    method: "DELETE",
  });
}

export function verifyStart(
  id: string,
): Promise<ApiResult<VerifyStartResponse>> {
  return request<VerifyStartResponse>(
    `/api/emergency-contacts/${id}/verify/start`,
    { method: "POST" },
  );
}

export function verifyConfirm(
  id: string,
  code: string,
): Promise<ApiResult<EmergencyContact>> {
  return request<EmergencyContact>(
    `/api/emergency-contacts/${id}/verify/confirm`,
    { method: "POST", body: { code } },
  );
}

export function sendTest(id: string): Promise<ApiResult<SmsTestResponse>> {
  return request<SmsTestResponse>(`/api/emergency-contacts/${id}/test`, {
    method: "POST",
  });
}

// Cycle 128: rewrite call_order to match `ordered_ids`. Returns the
// refreshed, re-ordered list.
export function reorder(
  orderedIds: string[],
): Promise<ApiResult<EmergencyContactListResponse>> {
  return request<EmergencyContactListResponse>(
    "/api/emergency-contacts/reorder",
    { method: "POST", body: { ordered_ids: orderedIds } },
  );
}

// Cycle 128: place one test voice call to a verified, voice-enabled contact.
export function voiceTest(id: string): Promise<ApiResult<VoiceTestResponse>> {
  return request<VoiceTestResponse>(
    `/api/emergency-contacts/${id}/voice-test`,
    { method: "POST" },
  );
}
